export const MESSAGE = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
};
